// src/lib/utils.ts

import { Timestamp } from 'firebase/firestore';

/**
 * 時刻をフォーマット
 */
export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * 日付をフォーマット
 */
export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 * Firestore Timestampを日時文字列に変換
 */
export const formatTimestamp = (timestamp: Timestamp | null): string => {
  if (!timestamp) return '-';
  return timestamp.toDate().toLocaleString('ja-JP', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * 分数を "HH:MM" 形式に変換
 */
export const formatDuration = (minutes: number | null | undefined): string => {
  // null, undefined, NaN, マイナス値の場合は 00:00 として扱う
  if (minutes === null || minutes === undefined || isNaN(minutes) || minutes < 0) {
    return '00:00';
  }
  
  const hours = Math.floor(minutes / 60);
  const mins = Math.floor(minutes % 60);
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};

/**
 * 分数を "X時間Y分" 形式に変換
 */
export const formatDurationJa = (minutes: number | null | undefined): string => {
  // null, undefined, NaN, マイナス値の場合は 0分 として扱う
  if (minutes === null || minutes === undefined || isNaN(minutes) || minutes < 0) {
    return '0分';
  }
  
  const hours = Math.floor(minutes / 60);
  const mins = Math.floor(minutes % 60);
  
  if (hours === 0) {
    return `${mins}分`;
  }
  if (mins === 0) {
    return `${hours}時間`;
  }
  return `${hours}時間${mins}分`;
};

/**
 * 2つのTimestamp間の分数を計算
 */
export const calculateMinutes = (start: Timestamp | null, end: Timestamp | null): number => {
  if (!start || !end) return 0;
  const diff = end.toMillis() - start.toMillis();
  return Math.floor(diff / 60000);
};

/**
 * クラス名を結合
 */
export const cn = (...classes: (string | boolean | undefined)[]): string => {
  return classes.filter(Boolean).join(' ');
};
